import * as Sentry from "@sentry/react";
import { TNotes } from "../types/index.type";

const serverType = process.env.REACT_APP_SERVER_TYPE;
export const determineBestAudioFormat = () => {
  const mimeTypes = [
    "audio/webm;codecs=opus",
    "audio/ogg;codecs=opus",
    "audio/mp4;codecs=mp4a.40.2",
    "audio/ogg;codecs=vorbis",
    "audio/wav",
  ];

  for (let mimeType of mimeTypes) {
    if (MediaRecorder.isTypeSupported(mimeType)) {
      return mimeType;
    }
  }

  return "audio/mp4";
};

export const isTooShort = (recordingTime: number) => {
  const minRecordingTime = serverType === "prod" ? 15 : 1; // 15 seconds
  return recordingTime < minRecordingTime;
};

export const isMaxTimedOut = (note: TNotes) => {
  // Use server-computed timeout flag. Fallback to error_status=5 for
  // backward compat with pre-existing DB records.
  return note.is_processing_timed_out === true || note.error_status === 5;
};

export const isCheckingAudioStatusForPolling = (note: TNotes) => {
  return note.status !== 1 && !isMaxTimedOut(note) && note.error_status === 0;
};

export const isMediaRecorderActive = (mediaRecorder: MediaRecorder | null) => {
  if (!mediaRecorder) return false;
  if (mediaRecorder.state === "inactive") {
    Sentry.captureMessage("MediaRecorder is inactive");
  }
  return mediaRecorder?.state !== "inactive";
};

export const stopMediaRecorderAndStopTracks = (mediaRecorder: MediaRecorder | null | undefined) => {
  if (!mediaRecorder) return;
  mediaRecorder.stop();
  mediaRecorder?.stream.getTracks().forEach((track) => {
    track.stop();
  });
  mediaRecorder?.removeEventListener("dataavailable", () => {
    console.log("data available event listener removed");
  });
};

export const pauseMediaRecorder = (mediaRecorder: MediaRecorder | null) => {
  if (!mediaRecorder || !isMediaRecorderActive(mediaRecorder)) return;

  mediaRecorder.pause();
};

export const resumeMediaRecorder = (mediaRecorder: MediaRecorder | null) => {
  if (!mediaRecorder || mediaRecorder.state !== "paused") return;

  mediaRecorder.resume();
};
